import type { DegreePlan_LearnerAdmissionStatus as LearnerAdmissionStatusType } from '__generated__/graphql-types';
import { DegreePlan_LearnerAdmissionStatus as LearnerAdmissionStatus } from '__generated__/graphql-types';

import type { UseCurriculum_SegmentCourseFragment as SegmentCourse } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';
import type {
  UseCurriculum_DegreeCurriculumFragment as DegreeCurriculum,
  UseCurriculum_PbaCurriculumFragment as PbaCurriculum,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useCurriculum';

// TODO: confirm BE FCND / Degree behaviour
const FCND_STATUSES: LearnerAdmissionStatusType[] = [LearnerAdmissionStatus.FcndNone, LearnerAdmissionStatus.FcndPba];
export const isFCND = (learnerAdmissionStatus: LearnerAdmissionStatusType) =>
  FCND_STATUSES.includes(learnerAdmissionStatus);

const DEGREE_STATUSES: LearnerAdmissionStatusType[] = [LearnerAdmissionStatus.Degree, LearnerAdmissionStatus.Pba];
export const isDegree = (learnerAdmissionStatus: LearnerAdmissionStatusType) =>
  DEGREE_STATUSES.includes(learnerAdmissionStatus);

/** Current date constructor, extracted for easier jest mocking */
export const now = () => new Date();

export const isDegreeCurriculum = (curr: DegreeCurriculum | PbaCurriculum): curr is DegreeCurriculum =>
  curr.__typename === 'DegreePlan_DegreeCurriculum';

export const isPbaCurriculum = (curr: DegreeCurriculum | PbaCurriculum): curr is PbaCurriculum =>
  curr.__typename === 'DegreePlan_PBACurriculum';

export const checkCourseHasUnknownAvailability = (segmentCourse: SegmentCourse): boolean =>
  segmentCourse.availabilityUnconfirmed;

/**
 * Finds the index of the last element based on the predicate by iterating the array backwards
 * @param array the given array
 * @param predicate the predicate, a function that returns a boolean value
 * @returns the index of the last element that satisfies the condition; if no such element is found, -1 is returned
 */
export const findLastIndex = <T>(array: Array<T>, predicate: (value: T) => boolean): number => {
  let l = array.length - 1;
  while (l >= 0) {
    if (predicate(array[l])) {
      return l;
    }
    l -= 1;
  }
  return -1;
};

export const isStringDefined = (s: string | undefined): s is string => s !== undefined;
